import { IncomingMessage } from "http";
import React,{useState} from "react";

export interface IContext {
    showText: boolean;
    setShowText: (showText: boolean) => void;
    setIncoming: (incomingTransaction: any) => void;
    setOutgoing: (outgoingTransaction: any) => void;
    setIncoming2: (incomingTransaction2: any) => void;
    setOutgoing2: (outgoingTransaction2: any) => void;
    incomingTransaction: any;
    setChild: (child: any) => void;
    child: any;
    outgoingTransaction: any;
    incomingTransaction2: any;
    outgoingTransaction2: any;
    address: string;
    setAddress: (address: string) => void;
    balance: string;
    setBalance: (address: string) => void;
    getValue: boolean;
    setGetValue: (getValue: boolean) => void;
    ID:number[];
    setID:React.Dispatch<React.SetStateAction<any[]>>
    maxIndex:number;
    childrens:any;
    pars:string[],
    setPars:React.Dispatch<React.SetStateAction<any[]>>;
    setChildrens:React.Dispatch<React.SetStateAction<any[]>>
    loading:boolean;
    load:boolean;
    nodes:any[];
    setNodes:React.Dispatch<React.SetStateAction<any[]>>
    links:any[];
    setLinks:React.Dispatch<React.SetStateAction<any[]>>
    list:any[];
    totalIncoming:number;
    totalOutgoing:number;
    setList:React.Dispatch<React.SetStateAction<any[]>>
    setLoading:React.Dispatch<React.SetStateAction<boolean>>
    setLoad:React.Dispatch<React.SetStateAction<boolean>>
    setMaxIndex:React.Dispatch<React.SetStateAction<number>>
    setTotalIncoming:React.Dispatch<React.SetStateAction<number>>
    setTotalOutgoing:React.Dispatch<React.SetStateAction<number>>
    setIncomingData:React.Dispatch<React.SetStateAction<any[]>>
    setOutgoingData:React.Dispatch<React.SetStateAction<any[]>>
    incomingData:any,
    outgoingData:any,
    setETHBalance:any,
    ETHBalance:any,

}

export const TextContext = React.createContext<IContext | null>(null);

interface Props {
    children: React.ReactNode;
  }
  
  

const TextProvider : React.FC<Props> = ({ children }) => {
const [showText, setShowText] = useState<boolean>(false);
const [getValue, setGetValue] = useState<boolean>(false);
const [incomingTransaction, setIncoming] = useState<any>([]);
const [ID,setID] = useState([])
const [loading,setLoading] = useState(false)
const [load,setLoad] = useState(false)
const [maxIndex, setMaxIndex] = useState(10)
const [child, setChild] = useState<any>("");
const [outgoingTransaction, setOutgoing] = useState<any>([]);
const [pars,setPars] = useState<any>([]);
const [incomingTransaction2, setIncoming2] = useState<any>([]);
const [outgoingTransaction2, setOutgoing2] = useState<any>([]);
const [childrens,setChildrens] = useState<any[]>([])
const [totalIncoming,setTotalIncoming] = useState<number>(0)
const [totalOutgoing,setTotalOutgoing] = useState<number>(0)
const [incomingData,setIncomingData] = useState<any>([])
const [ ETHBalance,setETHBalance] = useState<any>([])
const [outgoingData,setOutgoingData] = useState<any>([])
const [nodes,setNodes] = useState<any>([])
const [links,setLinks] = useState<any>([])
const [list,setList] = useState<any>([])

const [balance, setBalance] = useState<any>();

const [address,setAddress] = useState<string>("")
const contextValue = {
     showText,
     setShowText,
     setIncoming,
     setOutgoing,
    incomingTransaction,
    outgoingTransaction,
     address,
     pars,
     setPars,
     setAddress,
     balance,
     setBalance,
     getValue,
     setGetValue,
     childrens,
     setChildrens,
        setIncoming2,
        setOutgoing2,
        incomingTransaction2,
        outgoingTransaction2,
        child,
        setChild,
        loading,
        setLoading,
        load,
        setLoad,
        ID,
        setID,
        maxIndex,
        nodes,
        setNodes,
        links,
        setLinks,
        setMaxIndex,
        list,
        setETHBalance,
        ETHBalance,
        setList,
        totalIncoming,
        totalOutgoing,
        setTotalIncoming,
        setTotalOutgoing,
        incomingData,
        setIncomingData,
        outgoingData,
        setOutgoingData
    }
return (
    <TextContext.Provider value ={contextValue}>
        {children}
    </TextContext.Provider>
)
}

export default TextProvider